import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from 'app/src/queries/withCount';

export const TXN_LINES_WITH_COUNT = gql`
  query TxnLinesWithCount (
    ${WITH_COUNT_VARIABLES}
    $resourceType: String
    $resourceId: ID
  ) {
    txnLinesWithCount(
      ${WITH_COUNT_ARGUMENTS}
      resourceType: $resourceType
      resourceId: $resourceId
    ) {
      entries {
        id
        memo
        debitLessCredit
        creditLessDebit
        account { id name }
        asset { stockNumber }
        saleAsset { lotNumber }
        fee { type }
        txn {
          id
          type
          reference
          bankDate
          entityName
          buyerState
          locationStates
          sale { id name saleOn }
        }
      }
      count
    }
    resource (
      type: $resourceType
      id: $resourceId
    ) {
      name
      path
    }
  }
`;

export const REGISTER_FILTER_OPTIONS = gql`
  query NoUserLogRegisterFilterOptions {
    accounts { id fullName }
    sales { id name }
    buyers { id fullDisplayName }
    sellers { id fullDisplayName }
    feeTypes { id name }
  }
`;

export const TXN_LINE_TOTALS = gql`
  query TxnLineTotals (
    $search: String
    $filterColumns: [String!]
    $filterNames: [JSON!]
    $scopes: [String!]
    $resourceType: String
    $resourceId: ID
  ) {
    txnLineTotals(
      search: $search
      filterColumns: $filterColumns
      filterNames: $filterNames
      scopes: $scopes
      resourceType: $resourceType
      resourceId: $resourceId
    ) {
      count
      debitLessCredit
      creditLessDebit
    }
  }
`;
